import React from "react";
import { SignUp } from "aws-amplify-react";

// import { GoogleButton } from "./GoogleButtonSimple"
import { PhoneNumber } from "./PhoneNumber";

export class ArchieSignUp extends SignUp {
  constructor(props) {
    super(props);
    this._validAuthStates = ["signUp"];
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    super.signUp();
  }

  handlePhoneNumberChange(phoneNumber) {
    this.phone_number = phoneNumber;
  }

  showComponent() {
    if (this.checkCustomSignUpFields()) {
      this.signUpFields = this.props.signUpConfig.signUpFields;
    }
    this.sortFields();
    return (
      <div className="auth__signup">
        {/*<GoogleButton caption="Sign Up with Google"/>
        <div className="strike">Or</div>*/}
        <div className="form__help">
          Meet Archie, a selfservice portal that seamlessly provisions
          ready-to-use Well-Architected Cloud Resources and Infrastructures.{" "}
          <br />
          <br />
          <a
            href="https://youtu.be/J5XJ4t8GrW4"
            target="_blank"
            rel="noreferrer"
            className="link"
          >
            {" "}
            Watch our demo
          </a>
          <br /> <br />
        </div>
        <form
          className="auth__form form"
          onSubmit={this.handleSubmit}
          method="POST"
        >
          <div className="field">
            <label className="field__label" htmlFor="email">
              Email
            </label>
            <input
              className="field__input"
              id="email"
              key="email"
              name="email"
              required
              onChange={this.handleInputChange}
              type="text"
            />
          </div>

          <div className="field">
            <div className="field__header">
              <label className="field__label" htmlFor="phone_line_number">
                Phone Number
              </label>
            </div>
            <PhoneNumber onChange={this.handlePhoneNumberChange} />
          </div>

          <div className="field">
            <div className="field__header">
              <label className="field__label" htmlFor="password">
                Password
              </label>
            </div>
            <input
              className="field__input"
              id="password"
              key="password"
              name="password"
              required
              onChange={this.handleInputChange}
              type="password"
            />
          </div>
          <div className="form__actions">
            <button
              className="button button--large"
              disabled={this.state.requestPending}
            >
              Sign Up
            </button>
          </div>
          <div className="form__help">
            {/* Don't want to register yet?<br/>
            <a
              className="link"
              onClick={() => super.changeState("signIn")}
            >
              Sign in 
            </a>
            &nbsp; as default user and test a deployment.<br/>
            No Cloud account or credit card required ! 
            <br/><br/> */}
            Already a Member?{" "}
            <a className="link" onClick={() => super.changeState("signIn")}>
              Sign in
            </a>
          </div>
        </form>
      </div>
    );
  }
}

export default ArchieSignUp;
